import FetchClient from "./FetchClient";

export type ResaleMarketStatus =
  | "ok"
  | "no_match"
  | "skipped"
  | "unavailable"
  | "error"
  | "partial"
  | "budget";

export interface AmazonResale {
  status: ResaleMarketStatus;
  reason?: string;
  asin?: string;
  url?: string;
  /** Keyword search link, set when the product has no UPC (reason no_upc). */
  searchUrl?: string;
  buyBox?: number;
  avg90?: number;
  monthlySold?: number;
  referralFee?: number;
  fbaFee?: number;
  profit?: number;
  /** Percent, e.g. 21 for 21%. */
  roi?: number;
  fetchedAt?: string | number;
}

export interface EbaySale {
  title: string;
  price: number;
  condition: string;
  date: string;
  link: string;
}

export interface EbayResale {
  status: ResaleMarketStatus;
  reason?: string;
  query?: string;
  median?: number;
  count?: number;
  from?: string;
  to?: string;
  fee?: number;
  shipping?: number;
  profit?: number;
  /** Percent, e.g. 21 for 21%. */
  roi?: number;
  sales?: EbaySale[];
  searchUrl?: string;
  fetchedAt?: string | number;
}

export interface ResaleResult {
  upc: string;
  amazon: AmazonResale;
  ebay: EbayResale;
  best: "amazon" | "ebay" | "";
}

export interface ResaleRequest {
  upc: string;
  title: string;
  buyPrice: number;
  msrp?: number;
  units: number;
  retailer: string;
}

/** POST /v1/resale. Pro-only: non-Pro accounts get 403 {"error":"pro_required"}. */
export async function getResale(input: ResaleRequest): Promise<ResaleResult> {
  const response = await FetchClient.post<ResaleResult | { data: ResaleResult }>("/resale", input);
  // Accept both the bare contract body and the API's usual {data, status} envelope.
  if (response && typeof response === "object" && "data" in response && response.data && "amazon" in response.data) {
    return response.data;
  }
  return response as ResaleResult;
}

export function isProRequiredError(error: unknown): boolean {
  if (!error || typeof error !== "object") return false;
  const status = (error as { status?: number }).status;
  return status === 403;
}
